import { ChangeDetectionStrategy, Component, signal } from '@angular/core';
import { UiTextareaComponent } from '@system-dyg/shared/ui';
import { AppExampleSectionComponent } from '../../components/ds-example-section/ds-example-section.component';

@Component({
  selector: 'app-textarea-doc',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [UiTextareaComponent, AppExampleSectionComponent],
  templateUrl: './textarea-doc.component.html',
  styleUrl: './textarea-doc.component.scss',
})
export class TextareaDocComponent {
  protected readonly bio = signal('');
  protected readonly notes = signal('Texto de solo lectura que no puede editarse.');
  protected readonly limited = signal('');
  protected readonly isInvalid = signal(false);

  protected toggleInvalid(): void {
    this.isInvalid.update((v) => !v);
  }
}
